import { render, staticRenderFns } from "./CollectionPointList.vue?vue&type=template&id=a84de8ee"
import script from "./CollectionPointList.vue?vue&type=script&lang=js"
export * from "./CollectionPointList.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointList.vue?vue&type=style&index=0&id=a84de8ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports